import { render, staticRenderFns } from "./ClientRecognitionSettings.vue?vue&type=template&id=1ad7c4f4&scoped=true&"
import script from "./ClientRecognitionSettings.vue?vue&type=script&lang=js&"
export * from "./ClientRecognitionSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClientRecognitionSettings.vue?vue&type=style&index=0&id=1ad7c4f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7c4f4",
  null
  
)

export default component.exports